import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from './InstallationGroupItemsCard.rt';
import {selectItemUpdates} from '../../../selectors';
import * as actions from '../../../actions';
import _ from 'lodash';
import {AccessRights} from '../../../schemas/accessRightsModel';
import * as Misc from '../../../misc';
import {
  getActiveInstallationGroup
} from '../InstallationSelector';

function mapStateToProps(state, props) {
  const {installation} = props;
  const AR = AccessRights.get(state);
  const canEdit = AR.isSiteAdmin(false) || AR.isFabMaster() || AR.isFabAdmin();

  return {
    updatedInstallation: installation,
    units: state.installations.installationUnits,
    AR,
    canEdit,
    group: getActiveInstallationGroup(state)
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    updateTransientField: (key, value) => dispatch(actions.updateTransientField(ownProps.installation, key, value)),
    showEditGroupItem: (group, installation) => dispatch(actions.newInstallationGroupItem.showNewInstallationGroupItemOverlay(group, true, installation))
  };
}

class installationCreatorCard extends PureComponent {
  constructor(props) {
    super(props);
    let unitId = props.installation.installationUnit_id || 0;
    let unit = null;
    if(unitId > 0) {
      unit = _.find(props.units, u => u.id == unitId);
    } else if(props.units && props.units.length > 0) {
      unit = props.units[0];
    }

    this.state = {
      showingVisibility: false,
      name: props.updatedInstallation.name || '',
      price: props.updatedInstallation.price || '',
      forQuotingTool: props.updatedInstallation.forQuotingTool || false,
      forVisualizers: props.updatedInstallation.forVisualizers || '',
      unit: unit,
      updateFromProps: false
    };
  }

  forVisualizer = (visualizer) => {
    return (this.state.forVisualizers.toLowerCase().includes(_.trim(visualizer).toLowerCase()));
  }

  toggleForVisualizer = (visualizer) => {
    let vis = _.trim(visualizer).toLowerCase();
    if(visualizer == 'qt') {
      this.handleChangeEvent('forQuotingTool', !this.state.forQuotingTool);
      return;
    }
    let visList = _.trim(this.state.forVisualizers.toLowerCase()).split(',').filter(n => n);
    let index = visList.indexOf(vis);
    if(index >= 0) {
      visList.splice(index, 1);
    } else {
      visList.push(vis);
    }
    let forVisualizers = visList.join(',');
    this.handleChangeEvent('forVisualizers', forVisualizers);
  }

  handleChangeEvent = (key, value) => {
    this.setState({[key]: value}, () => this.props.updateTransientField(key, value));
  }

  handleVisibilityClick = (e, val) => {
    Misc.ignoreDefault(e);
    if(this.props.canEdit) {
      if(e.metaKey || e.ctrlKey) {
        this.toggleForVisualizer(val);
      } else {
        this.setState({showingVisibility: !this.state.showingVisibility});
      }
    }
  }

  getUnitOptions = () => {
    return _.map(this.props.units, u => ({
      value: u.unit,
      text: u.unit,
      baseObject: u,
      static: true}));
  }

  onChangeUnit = (value) => {
    let unit = _.find(this.getUnitOptions(), u => u.value == value).baseObject;
    this.setState({unit}, () => this.props.updateTransientField('unit', unit.id));
  }

  handleEditClick = () => {
    let installation = this.props.updatedInstallation;
    installation.forQuotingTool = this.state.forQuotingTool;
    installation.forVisualizers = this.state.forVisualizers;
    installation.name = this.state.name;
    installation.installationUnit_id = this.state.unit.id;
    this.props.showEditGroupItem(this.props.group, installation);
  }

  setUpdateFromProps = () => this.setState({updateFromProps: true})
  unsetUpdateFromProps = () => this.setState({updateFromProps: false})

  componentDidMount() {
    document.addEventListener('save-installation-validating', this.setUpdateFromProps);
    document.addEventListener('save-installation-complete', this.unsetUpdateFromProps);
  }

  componentWillUnmount() {
    document.removeEventListener('save-installation-validating', this.setUpdateFromProps);
    document.removeEventListener('save-installation-complete', this.unsetUpdateFromProps);
  }

  componentWillReceiveProps(newProps) {
    if(this.state.updateFromProps) {
      let unitId = newProps.installation.installationUnit_id || 0;
      let unit = null;
      if(unitId > 0) {
        unit = _.find(newProps.units, u => u.id == unitId);
      } else if(newProps.units && newProps.units.length > 0) {
        unit = newProps.units[0];
      }
      this.setState({
        name: newProps.updatedInstallation.name,
        price: newProps.updatedInstallation.price,
        forQuotingTool: newProps.updatedInstallation.forQuotingTool,
        forVisualizers: newProps.updatedInstallation.forVisualizers,
        unit: unit
      });
    }
  }

  render = template
}

installationCreatorCard.propTypes = {
  installation: PropTypes.object.isRequired,
  updatedInstallation: PropTypes.object.isRequired,
  updateTransientField: PropTypes.func.isRequired
};

const InstallationGroupItemsCard = connect(mapStateToProps, mapDispatchToProps)(installationCreatorCard);

export {InstallationGroupItemsCard};
